import { css } from 'styled-components';
import _ from 'lodash';
import { colorVariables, fontVariables } from 'theme/variables';

const base = css`
  position: static;
  margin: 0;
  font-weight: ${(props) =>
    props.font === 'inherit' && props.weight !== '' ? props.weight : 'inherit'};
  user-select: none;
  transition: color 135ms ease-in;

  ${(props) => css`
    color: ${_.get(
      colorVariables,
      props.color,
      colorVariables[props.theme.main_default]
    )};
    font-size: ${_.get(fontVariables, props.size, fontVariables.fs_xs)};
    &:hover {
      color: ${props.hover ? props.hover : null};
      transition: color 135ms ease-out;
    }
  `}

  ${(props) =>
    props.disable &&
    css`
      cursor: default;
      pointer-events: none;
    `}

  ${(props) =>
    props.type === 'interaction' &&
    css`
      cursor: pointer;
    `}
`;

export default base;
